import styled from '@emotion/styled';

export const ClickableAreaWrapper = styled.div<{ horizontalExtend?: number; verticalExtend?: number }>`
  position: relative;
  display: inline-block;

  &::after {
    content: '';
    position: absolute;
    top: -${({ verticalExtend }) => verticalExtend || 0}px;
    right: -${({ horizontalExtend }) => horizontalExtend || 0}px;
    bottom: -${({ verticalExtend }) => verticalExtend || 0}px;
    left: -${({ horizontalExtend }) => horizontalExtend || 0}px;
    cursor: pointer;
  }
`;
